import { render, staticRenderFns } from "./goods-sales.vue?vue&type=template&id=b0916e30&scoped=true&"
import script from "./goods-sales.vue?vue&type=script&lang=js&"
export * from "./goods-sales.vue?vue&type=script&lang=js&"
import style0 from "./goods-sales.vue?vue&type=style&index=0&id=b0916e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0916e30",
  null
  
)

export default component.exports